import { apiSlice } from 'store/slices/api/api-slice';
import {
    CreatNotificationRequest,
    NotificationResponseId,
} from 'types/notification/notification';

export const creatNotification = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        saveNotification: builder.mutation<
            NotificationResponseId,
            CreatNotificationRequest
        >({
            query: (creatNotificationRequest: CreatNotificationRequest) => ({
                url: '/notification/create-notification',
                method: 'POST',
                body: { ...creatNotificationRequest },
            }),
        }),

        updateNotification: builder.mutation<void, CreatNotificationRequest>({
            query: (creatNotificationRequest: CreatNotificationRequest) => ({
                url: '/notification/update-notification',
                method: 'POST',
                body: { ...creatNotificationRequest },
            }),
        }),

        notificationActivate: builder.mutation({
            query: (notificationId: string) => ({
                url: `/notification/activate-notification/` + notificationId,
                method: 'POST',
                header: {},
            }),
        }),
    }),
});
export const {
    useSaveNotificationMutation,
    useUpdateNotificationMutation,
    useNotificationActivateMutation,
} = creatNotification;
